import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useQuery } from 'react-query';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  selectSize,
  aptInfoDataList,
  modalState,
  currentRealEstateData,
  aptIdSelector,
  realEstateModalState,
  currentModalData,
  currentInnerWidth,
} from 'atoms';
import { aptInformationApi } from 'fetchers/currentValueApi';
import { realEstate } from 'fetchers/realEstateApi';
import ChartData from 'screen/ChartData';
import RealEstate from 'screen/RealEstate';
import RealEstateNewModal from 'components/RealEstateNewModal';
import RealEstateModal from 'components/RealEstateModal';
import Tab from './screen/Tab';
import Modal from './components/Modal';
import RealEstateCard from 'components/RealEstateCard';
import Title from 'components/Title';
import { Loader } from 'components/Loader';

const Main = () => {
  const [isRealEstateNewModalOpen, setIsRealEstateNewModalOpen] = useState(false);
  const [realEstateProviderData, setRealEstateProviderData] = useState([]);
  const [aptInfoData, setAptInfoData] = useRecoilState(aptInfoDataList);
  const [realEstateData, setRealEstateData] = useRecoilState(currentRealEstateData);
  const setSize = useSetRecoilState(selectSize);
  const setInnerWidth = useSetRecoilState(currentInnerWidth);
  const aptId = useRecoilValue(aptIdSelector);
  const modifyData = useRecoilValue(currentModalData);
  const isModalOpen = useRecoilValue(modalState);
  const isRealEstateModalOpen = useRecoilValue(realEstateModalState);

  const { isLoading } = useQuery('main_data', () => aptInformationApi(), {
    onSuccess: (data) => {
      data?.data[0]?.area_type.sort((a, b) => a.pyeong - b.pyeong);
      setSize(data.data[0].area_type[0].j_area);
      setAptInfoData(data.data[0].area_type);
    },
  });

  const { isLoading: fetchedRealEstateLoading } = useQuery('realEstate', () => realEstate.getData(aptId), {
    staleTime: 60 * 5000,
    onSuccess: (data) => setRealEstateData(data),
  });

  const { isLoading: fetchedRealEstateProviderLoading } = useQuery(
    'realEstateProvider',
    () => realEstate.getProviderBoardData(),
    {
      staleTime: 60 * 5,
      onSuccess: (data) => setRealEstateProviderData(data),
    },
  );

  const handleRealEstateAddButton = () => {
    setIsRealEstateNewModalOpen(true);
  };

  const throttle = (callback, limit = 100) => {
    let waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(() => {
          waiting = false;
        }, limit);
      }
    };
  };

  useEffect(() => {
    window.addEventListener(
      'resize',
      throttle(() => {
        setInnerWidth(window.innerWidth);
      }, 500),
    );

    return window.removeEventListener('resize', throttle);
  }, []);

  return (
    !isLoading && (
      <MainContainer className='w-100 d-flex flex-column'>
        <div className='d-flex flex-row justify-content-between align-items-center mt-3 mb-4'>
          <Title>부동산 소식</Title>
          <div className='row mx-3 mt-3'>
            <a href='?codeSeq=520'>
              <small className='text-primary'>
                전체보기<i class='bi bi-chevron-right pl-1'></i>
              </small>
            </a>
          </div>
        </div>
        {!fetchedRealEstateProviderLoading ? (
          realEstateProviderData.length > 0 && (
            <div>
              <div>
                {realEstateProviderData.map((data, idx) => (
                  <RealEstateCard idx={idx} data={data} length={realEstateProviderData} />
                ))}
              </div>
            </div>
          )
        ) : (
          <Loader />
        )}

        <ChartDataContainer className='border-top border-top-7 border-gray-100'>
          <Title>실거래가</Title>
          <Tab />
          <ChartData />
        </ChartDataContainer>
        {isModalOpen.state ? <Modal /> : null}

        {!fetchedRealEstateLoading && realEstateData?.providers?.length > 0 ? (
          <RealEstateWrapper className='border-top border-top-7 border-gray-100'>
            <Title>우리 아파트 공인중개사</Title>
            {realEstateData?.providers?.map((data, index) => {
              return <RealEstate key={index} data={data} />;
            })}
          </RealEstateWrapper>
        ) : (
          <RealEstateWrapper className='border-top'></RealEstateWrapper>
        )}

        {!!realEstateData?.isAdmin && realEstateData?.providers?.length < 2 && (
          <RealEstateAddButtonWrapper className='col-12 text-center' onClick={handleRealEstateAddButton}>
            <RealEstateAddButton className='btn btn-link btn-block text-gray-500'>추가</RealEstateAddButton>
          </RealEstateAddButtonWrapper>
        )}

        {isRealEstateModalOpen ? <RealEstateModal data={modifyData} /> : null}

        {isRealEstateNewModalOpen ? (
          <RealEstateNewModal setIsRealEstateNewModalOpen={setIsRealEstateNewModalOpen} />
        ) : null}

        <div className='m-2'>
          <small className='text-gray-400'>
            *부동산정보 컨텐츠는 제공 업체로부터 받는 정보 참고용입니다. 정보의 정확성이나 신뢰성을 아파트스토리가
            보증하지 않으며,서비스 이용의 결과에 대해서 법적인 책임을 지지 않습니다.
          </small>
        </div>
      </MainContainer>
    )
  );
};

const MainContainer = styled.div``;
const ChartDataContainer = styled.div``;
const RealEstateWrapper = styled.div``;
const RealEstateAddButtonWrapper = styled.div``;
const RealEstateAddButton = styled.button``;

export default Main;
